import { render, staticRenderFns } from "./budget-estimates.vue?vue&type=template&id=1387e3e6"
import script from "./budget-estimates.vue?vue&type=script&lang=js"
export * from "./budget-estimates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports